<template>
  <div>
    <h5>
      Rewards for <contest-link label="contest" :contestId="tmnt.id" />
    </h5>

    <contest-player-rewards-table
      v-if="tmnt.rewards !== null && tmnt.rewards.length > 0"
      :rewards="tmnt.rewards"
    />
  </div>
</template>

<script>
import ContestLink from './ContestLink.vue';
import ContestPlayerRewardsTable from './ContestPlayerRewardsTable.vue';

export default {
  name: 'PlayerContestRewards',

  components: {
    ContestLink,
    ContestPlayerRewardsTable,
  },

  props: {
    tmnt: {
      type: Object,
      required: true,
    }
  },
};
</script>

<style scoped>
.rewards-table {
  width: 1px;
}
</style>
